export default "https://cdn-web.disco.co/community_description-b5300629ef034cd4727e849730bc3e65.png";